// extracted by mini-css-extract-plugin
export default {"x-object-ui":"xObjectUI_x-object-ui__3B8A3","header":"xObjectUI_header__jM0QS","manual-input-row":"xObjectUI_manual-input-row__vhCNc"};